import React, { useEffect, useState, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Card,
  Grid,
  Tab,
  Paper,
  Container,
  Divider,
  Typography,
  Button,
  Link,
  IconButton,
} from "@mui/material";
import { Theme } from "@mui/material/styles";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import { styled } from "@mui/material/styles";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AddIcon from "@mui/icons-material/Add";
import CommonXGrid from "src/components/CommonXGrid/CommonXGrid";
import { GridColDef } from "@mui/x-data-grid-premium";
import ClearIcon from "@mui/icons-material/Clear";
import { useMyWinHeightContext } from "src/common/utils/getWindowDimensions";
import CommonTabs from "src/components/CommonTabs/CommonTabs";
import TabHeader from "src/components/TabHeader/TabHeader";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import { useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { useAppDispatch } from "src/app-redux/hooks";
import { submitFormData, downloadFileGet } from "src/app-redux/common-actions";
import { IVendorPaymentRemitDetails } from "src/common/typings/vendor/vendordetail";
import { Loader } from "src/components/atoms/Loader";
import AsynCommonAutoCompleteField from "src/components/CommonAutoCompleteField/AsynCommonAutoCompleteField";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonTextField from "src/components/CommonTextField/CommonTextField";
import AlertDialog from "src/components/AlertDialog/AlertDialog";
import CommonButton from "src/components/CommonButton/CommonButton";
import {
  getDocumentPreSignedURLForVendor,
  uploadDocument,
} from "src/app-redux/work-order/actions/workorderActions";
import { IDocumentResponse } from "src/common/typings/s3-file-metadata";
import * as yup from "yup";
import { getLocalDateTime } from "src/common/utils/app.util";
import { CurrentRemittanceInfo } from "./components/CurrentRemittanceInfo";
import { JsonDataDrawer } from "./components/JsonDataDrawer";
import { stringFormate } from "src/common/utils/helpers";
import CommonShowNotes from "src/components/molecules/CommonShowNotes";

const StyledPhoneInputContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  "& .react-tel-input": {
    "& .flag-dropdown": {
      border: "1px solid rgba(0, 0, 0, 0.23)",
      borderRight: "none",
      borderRadius: "4px 0 0 4px",
      backgroundColor: "transparent",
    },
    "& .form-control": {
      borderRadius: "4px",
    },
  },
}));

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    pageHeading: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: "bold",
      color: "#333",
    },
    sectionHeader: {
      background: "#f0f0f0",
      padding: "8px 16px",
      borderRadius: "4px 4px 0 0",
      marginBottom: "0px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      border: "1px solid #e0e0e0",
      borderBottom: "none",
    },
    sectionHeaderText: {
      fontWeight: "bold",
      fontSize: "14px",
      color: "#333",
    },
    sectionContent: {
      border: "1px solid #e0e0e0",
      padding: "16px",
      marginBottom: "20px",
      borderRadius: "0 0 4px 4px",
    },
    infoRow: {
      marginBottom: "8px",
      "& span": {
        fontWeight: "bold",
      },
    },
    downloadLink: {
      color: "#72CA00",
      textDecoration: "none",
      fontWeight: "bold",
      fontSize: "13px",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    tabCard: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    tabCardContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
    },
    cardMainParent: {
      float: "left",
      width: "100%",
    },
    cardMain: {
      marginBottom: "30px",
      paddingTop: "10px",
      width: "calc(100%)",
    },
    uploadBox: {
      background: "#f5f5f5",
      padding: "16px 24px",
      borderRadius: "4px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "20px",
      border: "1px dashed #e0e0e0",
    },
    uploadTitle: {
      fontWeight: "bold",
      color: "#666",
      fontSize: "14px",
    },
    uploadSubText: {
      color: "#999",
      fontSize: "12px",
    },
    chooseFileBtn: {
      background: "#e0e0e0",
      color: "#333",
      textTransform: "none",
      fontWeight: "bold",
      "&:hover": {
        background: "#d0d0d0",
      },
    },
    submitBtn: {
      background: "#72CA00",
      color: "#fff",
      fontWeight: "bold",
      textTransform: "none",
      padding: "8px 24px",
      "&:hover": {
        background: "#61ac00",
      },
      "&:disabled": {
        background: "#a5d6a7",
        color: "#fff",
      },
    },
    cancelBtn: {
      background: "#e0e0e0",
      color: "#333",
      fontWeight: "bold",
      textTransform: "none",
      padding: "8px 24px",
      marginRight: "16px",
      "&:hover": {
        background: "#d0d0d0",
      },
    },
    fileList: {
      marginTop: "10px",
      listStyle: "none",
      padding: 0,
    },
    fileItem: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "4px 12px",
      background: "#fff",
      border: "1px solid #eee",
      marginBottom: "4px",
      borderRadius: "4px",
    },
    historyTable: {
      "& .MuiTableCell-head": {
        fontWeight: "bold",
        color: "#333",
        background: "#fff",
        borderBottom: "2px solid #e0e0e0",
      },
      "& .MuiTableRow-root:nth-child(even)": {
        background: "#f9f9f9",
      },
    },
  })
);

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const selectRemitType = [
  { label: "Check", value: "Check" },
  { label: "ACH", value: "ACH" },
];

const validationSchema: any = yup.object().shape({
  eftBank: yup
    .string()
    .max(255)
    .default("")
    .test("superior", "ACH Bank is required", function (f) {
      const currentValue: string = f || "";
      const val = this.resolve(yup.ref("remitType"));
      if (val === "ACH") {
        return !!currentValue;
      }
      return true;
    }),
  eftEmail: yup
    .string()
    .max(255)
    .default("")
    .test("ach-email-required", "ACH Email is required", function (f) {
      const currentValue: string = f || "";
      const val = this.resolve(yup.ref("remitType"));
      if (val === "ACH") {
        return !!currentValue;
      }
      return true;
    })
    .test("ach-email-format", "ACH Email is invalid", function (f) {
      const currentValue: string = f || "";
      const val = this.resolve(yup.ref("remitType"));
      if (val === "ACH" && currentValue) {
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(currentValue);
      }
      return true;
    }),
  eftAcctnum: yup
    .string()
    .default("")
    .when("remitType", {
      is: "ACH",
      then: (schema) =>
        schema
          .required("ACH Account Number is required")
          .matches(/^\d+$/, "ACH Account Number must contain only numbers")
          .min(4, "ACH Account Number must be at least 4 digits")
          .max(17, "ACH Account Number must be at most 17 digits"),
      otherwise: (schema) => schema.notRequired(),
    }),
  eftBanknum: yup
    .string()
    .default("")
    .when("remitType", {
      is: "ACH",
      then: (schema) =>
        schema
          .required("ACH Routing Number is required")
          .matches(/^\d+$/, "ACH Routing Number must contain only numbers")
          .length(9, "ACH Routing Number must be 9 digits"),
      otherwise: (schema) => schema.notRequired(),
    }),
  checkCompany: yup
    .string()
    .max(255)
    .default("")
    .test("superior", "Company is required", function (f) {
      const currentValue: string = f || "";
      const val = this.resolve(yup.ref("remitType"));
      if (val === "Check") {
        return !!currentValue;
      }
      return true;
    }),
  checkAddress1: yup
    .string()
    .max(255)
    .default("")
    .test("superior", "Address 1 is required", function (f) {
      const currentValue: string = f || "";
      const val = this.resolve(yup.ref("remitType"));
      if (val === "Check") {
        return !!currentValue;
      }
      return true;
    }),
  checkCity: yup
    .string()
    .max(255)
    .default("")
    .test("city-required", "City is required", function (f) {
      const currentValue: string = f || "";
      const val = this.resolve(yup.ref("remitType"));
      if (val === "Check") {
        return !!currentValue;
      }
      return true;
    }),
  checkState: yup
    .string()
    .max(255)
    .default("")
    .test("state-required", "State is required", function (f) {
      const currentValue: string = f || "";
      const val = this.resolve(yup.ref("remitType"));
      if (val === "Check") {
        return !!currentValue;
      }
      return true;
    }),
  checkZip: yup
    .string()
    .max(255)
    .default("")
    .test("zip-required", "Zip is required", function (f) {
      const currentValue: string = f || "";
      const val = this.resolve(yup.ref("remitType"));
      if (val === "Check") {
        return !!currentValue;
      }
      return true;
    }),
  checkPhone: yup
    .string()
    .default("")
    .test("phone-required", "Phone Number is required", function (f) {
      const currentValue: string = f || "";
      const val = this.resolve(yup.ref("remitType"));
      if (val === "Check") {
        // Phone with country code should be at least 11 digits (1 + 10 for US)
        const digits = currentValue.replace(/\D/g, "");
        return digits.length >= 11;
      }
      return true;
    }),
  achDocuments: yup
    .array()
    .test("at-least-one", "At least one document is required for ACH", function (value) {
      const val = this.resolve(yup.ref("remitType"));
      if (val === "ACH") {
        return !!(value && value.length > 0);
      }
      return true;
    }),
});

export function PaymentRemittancePage(): React.ReactElement {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const { winHeight } = useMyWinHeightContext();
  const [value, setValue] = useState(0);
  const [states1, setStates1] = useState<any[]>([]);
  const [cities1, setCities1] = useState<any[]>([]);
  const [loader, setLoader] = useState(false);
  const [openSubmission, setOpenSubmission] = useState<any>(null);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

  const [historyData, setHistoryData] = useState([]);
  const [isJsonDrawerOpen, setIsJsonDrawerOpen] = useState(false);
  const [selectedJsonApprovalId, setSelectedJsonApprovalId] = useState<number | null>(null);
  const [isCommentDrawerOpen, setIsCommentDrawerOpen] = useState(false);
  const [currentComment, setCurrentComment] = useState<string>("");

  const fileInputRef = useRef<HTMLInputElement>(null);

  const historyColumns: GridColDef[] = [
    {
      field: "submittedDate",
      headerName: "Submitted Date",
      width: 200,
      type: "date",
    },
    {
      field: "comment",
      headerName: "Comment",
      width: 250,
      renderCell: (params: any) => {
        const commentValue = params.value || "";
        if (!commentValue) return null;
        return (
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setCurrentComment(commentValue);
              setIsCommentDrawerOpen(true);
            }}
            color="primary"
            sx={{
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "100%",
            }}
            data-testid="comment-link"
          >
            {stringFormate(commentValue)}
          </Link>
        );
      },
    },
    {
      field: "resolutionDate",
      headerName: "Resolution Date",
      width: 200,
      type: "date",
    },
    {
      field: "approvalStatus",
      headerName: "Approval Status",
      width: 150,
    },
    {
      field: "submissionJson",
      headerName: "Submission JSON",
      width: 180,
      disableExport: true,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => {
        const approvalId = params?.row?.id;
        if (approvalId == null || approvalId === undefined) return null;
        return (
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setSelectedJsonApprovalId(Number(approvalId));
              setIsJsonDrawerOpen(true);
            }}
            color="primary"
            sx={{ display: "flex", alignItems: "center" }}
            data-testid="json-data-link"
          >
            <img src="/FileJSON.svg" alt="JSON" style={{ width: 20, height: 20 }} />
          </Link>
        );
      },
    },
  ];

  async function getHistoryData() {
    setLoader(true);
    const FETCH_HISTORY_ENDPOINT = `get-payment-remittance-history-by-vendor-id`;
    try {
      const data = await fetchWrapper.get(FETCH_HISTORY_ENDPOINT);
      if (data.length > 0) {
        const transformedData = data.map((dd: any) => {
          return {
            ...dd,
            submittedDate: getLocalDateTime(dd.submittedDate, "MM/DD/YYYY hh:mm A"),
            resolutionDate: dd.resolutionDate
              ? getLocalDateTime(dd.resolutionDate, "MM/DD/YYYY hh:mm A")
              : "",
          };
        });
        setHistoryData(transformedData);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }

  const downloadExcel = async () => {
    try {
      await dispatch(downloadFileGet("/download-mass-import-template/VendorRemittanceTemplate"));
    } catch (error) {
      console.error(error);
    }
  };

  const ALLOWED_FILE_EXTENSIONS = [".pdf", ".jpg", ".jpeg", ".png", ".tif", ".tiff"];
  const ALLOWED_MIME_TYPES = {
    "application/pdf": [".pdf"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/tiff": [".tif", ".tiff"],
  };

  const validateFileType = (file: File): boolean => {
    const fileName = file.name.toLowerCase();
    return ALLOWED_FILE_EXTENSIONS.some((ext) => fileName.endsWith(ext));
  };

  const [fileTypeError, setFileTypeError] = useState<string | null>(null);
  const [achDocumentsLocal, setAchDocumentsLocal] = useState<File[]>([]);

  const onDrop = useCallback((acceptedFiles: File[], rejectedFiles: any[]) => {
    const validFiles: File[] = [];
    const invalidFiles: string[] = [];

    acceptedFiles.forEach((file) => {
      if (validateFileType(file)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    rejectedFiles.forEach((rejection) => {
      invalidFiles.push(rejection.file.name);
    });

    if (invalidFiles.length > 0) {
      setFileTypeError(
        `Invalid file type(s): ${invalidFiles.join(
          ", "
        )}. Supported formats: PDF, JPG, JPEG, PNG, TIF, TIFF`
      );
    } else {
      setFileTypeError(null);
    }

    if (validFiles.length > 0) {
      setAchDocumentsLocal((prev) => [...prev, ...validFiles]);
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: ALLOWED_MIME_TYPES as any,
    noClick: true,
  });

  async function checkOpenSubmissions() {
    const openSub: any = historyData.find((item: any) => item.approvalStatus === "Submitted");
    if (openSub) {
      setOpenSubmission(openSub);
      return true;
    }
    return false;
  }

  const formik = useFormik<IVendorPaymentRemitDetails>({
    enableReinitialize: false,
    initialValues: {
      id: parseInt(id) || 0,
      checkCompany: "",
      checkAddress1: "",
      isCheckAddress: false,
      checkAddress2: "",
      checkCity: "",
      checkState: "",
      checkZip: "",
      checkPhone: "",
      checkContact: "",
      eftBanknum: "",
      eftAcctnum: "",
      eftEmail: "",
      eftBank: "",
      remitType: "Check",
      checkDBA: "",
      achDocuments: [],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const hasOpen = await checkOpenSubmissions();
      if (hasOpen) {
        setIsConfirmDialogOpen(true);
      } else {
        performSubmit(values);
      }
    },
  });

  // Sync achDocumentsLocal (from dropzone) with formik
  useEffect(() => {
    if (achDocumentsLocal.length > 0) {
      formik.setFieldValue("achDocuments", [
        ...(formik.values.achDocuments || []),
        ...achDocumentsLocal,
      ]);
      setAchDocumentsLocal([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [achDocumentsLocal]);

  const performSubmit = async (values: IVendorPaymentRemitDetails) => {
    setLoader(true);
    try {
      const clone = JSON.parse(JSON.stringify(values));
      if (clone.checkPhone && clone.checkPhone.length > 3)
        clone.checkPhone = clone.checkPhone.replace(/[()' '-]/g, "");

      let uploadedDocuments = [];
      if (values.remitType === "ACH" && values.achDocuments) {
        for (const file of values.achDocuments) {
          const document: any = {
            FileName: file?.name,
            Type: "Banking Information",
            ContentType: file?.type,
            FileExtension: file?.name.split(".")[1],
            VendNum: 0,
            Comment: "",
          };

          const res: any = await dispatch(getDocumentPreSignedURLForVendor(document));
          if (res?.payload) {
            const payload = res.payload as IDocumentResponse;
            try {
              const res1: any = await dispatch(
                uploadDocument({
                  url: payload.url,
                  formData: file,
                  contentType: document.ContentType,
                  size: file.size,
                  mgsNotShown: true,
                  includedEncoding: true,
                  cusMessage: "Something went wrong - please try again. If the problem persists, try again later or contact us for assistance.",
                })
              );

              if (res1?.payload && !res1.error) {
                uploadedDocuments.push({
                  document_id: parseInt(payload.documentId),
                  file_name: file.name,
                  doc_type: file.type,
                });
              } else {
                throw new Error("Document upload failed");
              }
            } catch (uploadError) {
              setLoader(false);
              setIsConfirmDialogOpen(false);
              return;
            }
          } else {
            setLoader(false);
            setIsConfirmDialogOpen(false);
            return;
          }
        }
      }

      const body = {
        context: {
          approvalType: "Payment Remittance",
          remitType: clone.remitType,
          vendorId: clone.id,
          details:
            clone.remitType === "Check"
              ? {
                  company: clone.checkCompany,
                  address1: clone.checkAddress1,
                  address2: clone.checkAddress2,
                  city: clone.checkCity,
                  state: clone.checkState,
                  zip: clone.checkZip,
                  phone: clone.checkPhone,
                  contact: clone.checkContact,
                  dba: clone.checkDBA,
                }
              : {
                  email: clone.eftEmail,
                  bank: clone.eftBank,
                  routing: clone.eftBanknum,
                  accountNumber: clone.eftAcctnum,
                  documents: uploadedDocuments,
                },
        },
      };

      const SAVE_FORM_DATA_ENDPOINT = "create-remittance-approval";
      await dispatch(
        submitFormData(
          SAVE_FORM_DATA_ENDPOINT,
          body,
          "Payment Remittance request submitted for approval successfully!"
        )
      );
      setIsConfirmDialogOpen(false);
      getHistoryData();
      formik.resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const handleCancel = () => {
    formik.resetForm();
    setFileTypeError(null);
  };

  const resetStatesAndCities = async () => {
    setLoader(true);
    try {
      const res1 = await fetchWrapper.get("/get-states");
      if (res1?.states) {
        setStates1(res1.states.map((s: string) => ({ label: s, value: s })));
      }
      const res2 = await fetchWrapper.get("/get-cities");
      if (res2?.cities) {
        setCities1(res2.cities);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getValueWRTzip1 = async (zip: string) => {
    setLoader(true);
    try {
      const result: any = await fetchWrapper.get(`/get-cities-states-counties-by-zip/${zip}`);
      if (result?.data) {
        const { states, cities } = result.data;
        if (cities?.length) {
          setStates1(states.map((s: string) => ({ label: s, value: s })));
          setCities1(cities);
        } else {
          formik.setFieldValue("checkZip", "");
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getCitiesWRTstate1 = async (st: string) => {
    setLoader(true);
    try {
      const result = await fetchWrapper.get(`/get-cities/${st}`);
      if (result?.cities) {
        setCities1(result.cities);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getHistoryData();
    resetStatesAndCities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (historyData.length > 0) {
      checkOpenSubmissions();
    }
  }, [historyData]);

  const removeFile = (index: number) => {
    const newDocs = [...(formik.values.achDocuments || [])];
    newDocs.splice(index, 1);
    formik.setFieldValue("achDocuments", newDocs);
  };

  const handleChooseFile = () => {
    fileInputRef.current?.click();
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      const validFiles: File[] = [];
      const invalidFiles: string[] = [];

      files.forEach((file) => {
        if (validateFileType(file)) {
          validFiles.push(file);
        } else {
          invalidFiles.push(file.name);
        }
      });

      if (invalidFiles.length > 0) {
        setFileTypeError(
          `Invalid file type(s): ${invalidFiles.join(
            ", "
          )}. Supported formats: PDF, JPG, JPEG, PNG, TIF, TIFF`
        );
      } else {
        setFileTypeError(null);
      }

      if (validFiles.length > 0) {
        formik.setFieldValue("achDocuments", [
          ...(formik.values.achDocuments || []),
          ...validFiles,
        ]);
      }

      // Reset the input value to allow selecting the same file again
      e.target.value = "";
    }
  };

  const wHeight = winHeight - 138;
  const accordionMaxHeight = winHeight - 193;
  const tabMinHeight = winHeight - 255;
  const minAddTabHeight = 60;

  return (
    <>
      <TabHeader
        module={"Company Profile"}
        heading={"Payment Remittance"}
        linkTo="company-profile"
        pageTitle="TFG | Portal | Payment Remittance"
      />
      <Box m={2} />

      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent} style={{ height: wHeight }}>
          <Paper elevation={3} className={classes.cardMain} style={{ height: wHeight }}>
            <Box pl={2} pr={2} py={1}>
              <Grid container direction="row" alignItems="center" justifyContent="space-between">
                <Grid item>
                  <Typography className={classes.pageHeading}>{"Payment Remittance"}</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box m={0}>
              <Divider />
            </Box>

            <Grid container>
              <Grid item md={2}>
                <Card className={classes.tabCard}>
                  <CommonTabs
                    value={value}
                    handleChange={() => {}}
                    tabMinHeight={tabMinHeight}
                    minHeight={tabMinHeight + minAddTabHeight}
                  >
                    <Tab label="Payment Remittance" {...a11yProps(0)} />
                  </CommonTabs>
                </Card>
              </Grid>
              <Grid item md={10}>
                <Card
                  className={classes.tabCardContent}
                  style={{ height: accordionMaxHeight, overflowY: "auto" }}
                >
                  <Container maxWidth="lg">
                    <Box p={3}>
                      <Loader open={loader} />

                      {/* SECTION 1: Current Payment Remittance Info */}
                      <CurrentRemittanceInfo />

                      {/* SECTION 2: Update Payment Remittance Form */}
                      <Box mt={openSubmission ? 2 : 0}>
                        <Box className={classes.sectionHeader}>
                          <Typography className={classes.sectionHeaderText}>
                            Update Payment Remittance
                          </Typography>
                        </Box>
                        <Box className={classes.sectionContent}>
                          <Grid container direction="row">
                            <Grid item xs={12} md={12}>
                              <Box>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item xs={12} md={4}>
                                    <CommonAutoCompleteField
                                      label="Remittance Type"
                                      optionsType={selectRemitType}
                                      getOptionLabel={(option: any) => option.label || ""}
                                      value={
                                        selectRemitType.find(
                                          (ty: any) => ty.value === formik.values.remitType
                                        ) || null
                                      }
                                      onChange={(option: any) =>
                                        formik.setValues({
                                          ...formik.values,
                                          remitType: option.value || "",
                                          checkCompany: "",
                                          checkAddress1: "",
                                          checkAddress2: "",
                                          checkCity: "",
                                          checkState: "",
                                          checkZip: "",
                                          checkPhone: "",
                                          checkContact: "",
                                          eftEmail: "",
                                          eftBank: "",
                                          eftBanknum: "",
                                          eftAcctnum: "",
                                          isCheckAddress: false,
                                          achDocuments: [],
                                        })
                                      }
                                      disableClearable
                                    />
                                  </Grid>

                                  {formik.values.remitType === "Check" && (
                                    <>
                                      <Grid item xs={12} md={12} />
                                      <Grid item xs={12} md={4}>
                                        <CommonTextField
                                          label="Company"
                                          name="checkCompany"
                                          value={formik.values.checkCompany}
                                          onChange={formik.handleChange}
                                          error={
                                            formik.touched.checkCompany &&
                                            Boolean(formik.errors.checkCompany)
                                          }
                                          helperText={
                                            formik.touched.checkCompany &&
                                            formik.errors.checkCompany
                                          }
                                          required
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={4}>
                                        <StyledPhoneInputContainer>
                                          <Typography
                                            component="label"
                                            variant="body2"
                                            sx={{
                                              position: "absolute",
                                              top: "-9px",
                                              left: "12px",
                                              backgroundColor: "#fff",
                                              padding: "0 4px",
                                              fontSize: "11px",
                                              fontWeight: "400",
                                              color:
                                                formik.touched.checkPhone &&
                                                formik.errors.checkPhone
                                                  ? "#d32f2f"
                                                  : "rgba(0, 0, 0, 0.6)",
                                              pointerEvents: "none",
                                              zIndex: 3,
                                            }}
                                          >
                                            Phone Number *
                                          </Typography>
                                          <PhoneInput
                                            country={"us"}
                                            value={formik.values.checkPhone}
                                            onChange={(value: string) => {
                                              formik.setFieldValue("checkPhone", value);
                                            }}
                                            inputStyle={{
                                              width: "100%",
                                              height: "37px",
                                              fontSize: "16px",
                                              paddingLeft: "48px",
                                              borderRadius: "4px",
                                              border:
                                                formik.touched.checkPhone &&
                                                formik.errors.checkPhone
                                                  ? "1px solid #d32f2f"
                                                  : "1px solid rgba(0, 0, 0, 0.23)",
                                            }}
                                            containerStyle={{
                                              width: "100%",
                                            }}
                                          />
                                          {formik.touched.checkPhone &&
                                            formik.errors.checkPhone && (
                                              <Typography
                                                variant="caption"
                                                color="error"
                                                sx={{ mt: 0.5, ml: 1.5 }}
                                              >
                                                {formik.errors.checkPhone}
                                              </Typography>
                                            )}
                                        </StyledPhoneInputContainer>
                                      </Grid>
                                      <Grid item xs={12} md={4}>
                                        <CommonTextField
                                          label="Contact"
                                          name="checkContact"
                                          value={formik.values.checkContact}
                                          onChange={formik.handleChange}
                                          error={
                                            formik.touched.checkContact &&
                                            Boolean(formik.errors.checkContact)
                                          }
                                          helperText={
                                            formik.touched.checkContact &&
                                            formik.errors.checkContact
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <CommonTextField
                                          label="Address 1"
                                          name="checkAddress1"
                                          value={formik.values.checkAddress1}
                                          onChange={formik.handleChange}
                                          error={
                                            formik.touched.checkAddress1 &&
                                            Boolean(formik.errors.checkAddress1)
                                          }
                                          helperText={
                                            formik.touched.checkAddress1 &&
                                            formik.errors.checkAddress1
                                          }
                                          required
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <CommonTextField
                                          label="Address 2"
                                          name="checkAddress2"
                                          value={formik.values.checkAddress2}
                                          onChange={formik.handleChange}
                                          error={
                                            formik.touched.checkAddress2 &&
                                            Boolean(formik.errors.checkAddress2)
                                          }
                                          helperText={
                                            formik.touched.checkAddress2 &&
                                            formik.errors.checkAddress2
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={3}>
                                        <AsynCommonAutoCompleteField
                                          label="City"
                                          name="checkCity"
                                          optionsType={cities1}
                                          getOptionLabel={(option: any) => option || ""}
                                          value={
                                            cities1.find((city: any) => {
                                              const cityValue = city?.toLowerCase?.() || "";
                                              const checkCityValue =
                                                formik.values.checkCity?.toLowerCase?.() || "";
                                              return cityValue === checkCityValue;
                                            }) || null
                                          }
                                          handleChange={(v) => {
                                            formik.setFieldValue("checkCity", v);
                                          }}
                                          required
                                          error={
                                            formik.touched.checkCity &&
                                            Boolean(formik.errors.checkCity)
                                          }
                                          helperText={
                                            formik.touched.checkCity && formik.errors.checkCity
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={3}>
                                        <CommonAutoCompleteField
                                          label="State"
                                          optionsType={(states1 as any) || []}
                                          getOptionLabel={(option: any) => option.label || ""}
                                          error={
                                            formik.touched.checkState &&
                                            Boolean(formik.errors.checkState)
                                          }
                                          helperText={
                                            formik.touched.checkState && formik.errors.checkState
                                          }
                                          value={
                                            states1.find(
                                              (p: any) => p.value === formik.values.checkState
                                            ) || null
                                          }
                                          onChange={(v: any) => {
                                            if (!v) {
                                              formik.setValues({
                                                ...formik.values,
                                                checkState: "",
                                                checkZip: "",
                                                checkCity: "",
                                              });
                                              resetStatesAndCities();
                                            } else {
                                              formik.setFieldValue("checkState", v.value || "");
                                              if (!formik.values.checkZip)
                                                getCitiesWRTstate1(v.value);
                                            }
                                          }}
                                          required
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={3}>
                                        <CommonTextField
                                          label="Zip"
                                          name="checkZip"
                                          value={formik.values.checkZip}
                                          onChange={formik.handleChange}
                                          onBlur={(e: any) => {
                                            if (e.currentTarget.value) {
                                              getValueWRTzip1(e.currentTarget.value);
                                            } else {
                                              resetStatesAndCities();
                                            }
                                          }}
                                          error={
                                            formik.touched.checkZip &&
                                            Boolean(formik.errors.checkZip)
                                          }
                                          helperText={
                                            formik.touched.checkZip && formik.errors.checkZip
                                          }
                                          required
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={3}>
                                        <CommonTextField
                                          label="DBA"
                                          name="checkDBA"
                                          value={formik.values.checkDBA}
                                          onChange={formik.handleChange}
                                          error={
                                            formik.touched.checkDBA &&
                                            Boolean(formik.errors.checkDBA)
                                          }
                                          helperText={
                                            formik.touched.checkDBA && formik.errors.checkDBA
                                          }
                                        />
                                      </Grid>
                                    </>
                                  )}
                                  {formik.values.remitType === "ACH" && (
                                    <>
                                      <Grid item xs={12} md={6} style={{ marginTop: 8 }}>
                                        <Link
                                          onClick={downloadExcel}
                                          className={classes.downloadLink}
                                        >
                                          Download ACH Form (Required)
                                        </Link>
                                      </Grid>
                                      <Grid item xs={12} md={4}>
                                        <CommonTextField
                                          label="ACH Email"
                                          name="eftEmail"
                                          value={formik.values.eftEmail}
                                          onChange={formik.handleChange}
                                          error={
                                            formik.touched.eftEmail &&
                                            Boolean(formik.errors.eftEmail)
                                          }
                                          helperText={
                                            formik.touched.eftEmail && formik.errors.eftEmail
                                          }
                                          required
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={4}>
                                        <CommonTextField
                                          label="ACH Bank"
                                          name="eftBank"
                                          value={formik.values.eftBank}
                                          onChange={formik.handleChange}
                                          error={
                                            formik.touched.eftBank && Boolean(formik.errors.eftBank)
                                          }
                                          helperText={
                                            formik.touched.eftBank && formik.errors.eftBank
                                          }
                                          required
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={4}>
                                        <CommonTextField
                                          label="ACH Routing"
                                          name="eftBanknum"
                                          value={formik.values.eftBanknum}
                                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            const value = e.target.value.replace(/\D/g, "");
                                            formik.setFieldValue("eftBanknum", value);
                                          }}
                                          error={
                                            formik.touched.eftBanknum &&
                                            Boolean(formik.errors.eftBanknum)
                                          }
                                          helperText={
                                            formik.touched.eftBanknum && formik.errors.eftBanknum
                                          }
                                          required
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={4}>
                                        <CommonTextField
                                          label="ACH Account Number"
                                          name="eftAcctnum"
                                          value={formik.values.eftAcctnum}
                                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            const value = e.target.value.replace(/\D/g, "");
                                            formik.setFieldValue("eftAcctnum", value);
                                          }}
                                          error={
                                            formik.touched.eftAcctnum &&
                                            Boolean(formik.errors.eftAcctnum)
                                          }
                                          helperText={
                                            formik.touched.eftAcctnum && formik.errors.eftAcctnum
                                          }
                                          required
                                        />
                                      </Grid>

                                      <Grid item xs={12}>
                                        <Box {...getRootProps()} className={classes.uploadBox}>
                                          <input {...getInputProps()} />
                                          <input
                                            type="file"
                                            multiple
                                            accept=".pdf,.jpg,.jpeg,.png,.tif,.tiff"
                                            style={{ display: "none" }}
                                            ref={fileInputRef}
                                            onChange={handleFileInputChange}
                                            data-testid="hidden-file-input"
                                          />
                                          <Box>
                                            <Typography className={classes.uploadTitle}>
                                              Upload ACH Form (Required)
                                            </Typography>
                                            <Typography className={classes.uploadSubText}>
                                              At least one document upload is required. Supported
                                              formats: PDF, JPG, JPEG, PNG, TIF, TIFF
                                            </Typography>
                                          </Box>
                                          <Button
                                            variant="contained"
                                            className={classes.chooseFileBtn}
                                            startIcon={<AddIcon />}
                                            onClick={handleChooseFile}
                                          >
                                            Choose File
                                          </Button>
                                        </Box>

                                        <ul className={classes.fileList}>
                                          {(formik.values.achDocuments || []).map(
                                            (file: File, index: number) => (
                                              <li key={index} className={classes.fileItem}>
                                                <Typography variant="body2">{file.name}</Typography>
                                                <IconButton
                                                  size="small"
                                                  color="error"
                                                  onClick={() => removeFile(index)}
                                                  aria-label="delete-file"
                                                >
                                                  <ClearIcon fontSize="small" />
                                                </IconButton>
                                              </li>
                                            )
                                          )}
                                        </ul>
                                        {fileTypeError && (
                                          <Typography
                                            variant="caption"
                                            color="error"
                                            data-testid="fileType-error"
                                            sx={{ display: "block", mt: 1 }}
                                          >
                                            {fileTypeError}
                                          </Typography>
                                        )}
                                        {formik.touched.achDocuments &&
                                          formik.errors.achDocuments && (
                                            <Typography
                                              variant="caption"
                                              color="error"
                                              data-testid="achDocuments-error"
                                            >
                                              {String(formik.errors.achDocuments)}
                                            </Typography>
                                          )}
                                      </Grid>
                                    </>
                                  )}
                                </Grid>

                                <Box mt={4} mb={2} textAlign="right">
                                  <CommonButton
                                    //className={classes.cancelBtn}
                                    onClick={handleCancel}
                                  >
                                    Reset
                                  </CommonButton>
                                  <CommonButton
                                    onClick={() => formik.submitForm()}
                                    disable={loader}
                                    isGreen
                                  >
                                    Submit Request
                                  </CommonButton>
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>

                      {/* SECTION 3: Approval History */}
                      <Box className={classes.sectionHeader}>
                        <Typography className={classes.sectionHeaderText}>
                          Approval History
                        </Typography>
                      </Box>
                      <Box className={classes.sectionContent} style={{ padding: 0 }}>
                        <CommonXGrid
                          rows={historyData}
                          columns={historyColumns}
                          defaultPerPageRecord={10}
                          height={300}
                          initVal={{ sortModel: [] }}
                        />
                      </Box>

                      <AlertDialog
                        isOpen={isConfirmDialogOpen}
                        handleClose={() => setIsConfirmDialogOpen(false)}
                        message={
                          <>
                            <strong>Warning:</strong> You already have an open submission for
                            Payment Remittance. Submitting this will close your previous request.{" "}
                            <strong>Do you want to proceed?</strong>
                          </>
                        }
                        primaryButtonText="Proceed"
                        onPrimaryButtonClick={() => performSubmit(formik.values)}
                        heading={"Confirm Submission"}
                      />

                      <JsonDataDrawer
                        isOpen={isJsonDrawerOpen}
                        onClose={() => {
                          setIsJsonDrawerOpen(false);
                          setSelectedJsonApprovalId(null);
                        }}
                        approvalId={selectedJsonApprovalId}
                      />
                      <CommonShowNotes
                        open={isCommentDrawerOpen}
                        closed={() => setIsCommentDrawerOpen(false)}
                        selectedData={currentComment}
                        title="Comment"
                      />
                    </Box>
                  </Container>
                </Card>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
